import { Component } from "@angular/core";

@Component({
    selector: 'app-preventivi-list-page',
    templateUrl: './preventivi-list-page.component.html'
})

export class PreventiviListPageComponent  {
}